import { Zap, Shield, Star, Users, TrendingDown, Lock } from "lucide-react"

const features = [
  {
    icon: TrendingDown,
    title: "You Set the Price",
    description: "Name your price for any service. Providers compete for your business.",
    gradient: "from-green-500/10 to-emerald-500/10",
  },
  {
    icon: Users,
    title: "Direct Communication",
    description: "Chat directly with providers to negotiate and finalize details.",
    gradient: "from-blue-500/10 to-cyan-500/10",
  },
  {
    icon: Shield,
    title: "Verified Providers Only",
    description: "Every provider is verified. Quality and safety are guaranteed.",
    gradient: "from-purple-500/10 to-pink-500/10",
  },
  {
    icon: Lock,
    title: "Secure Payments",
    description: "Your payments are protected. Book with complete confidence.",
    gradient: "from-red-500/10 to-orange-500/10",
  },
  {
    icon: Star,
    title: "Real Reviews",
    description: "Transparent ratings from real customers help you choose wisely.",
    gradient: "from-yellow-500/10 to-amber-500/10",
  },
  {
    icon: Zap,
    title: "Instant Booking",
    description: "Accept an offer and book instantly. No waiting, no hassle.",
    gradient: "from-[#DB4789]/10 to-pink-500/10",
  },
]

export function KeyFeatures() {
  return (
    <section className="py-20 md:py-32 bg-gradient-to-b from-gray-50 to-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#75055B]/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#DB4789]/5 rounded-full blur-3xl" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-block px-4 py-2 bg-[#DB4789]/10 rounded-full mb-6">
              <span className="text-sm font-semibold text-[#75055B]">Key Features</span>
            </div>
            <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-6">
              Built for <span className="bg-gradient-to-r from-[#75055B] to-[#DB4789] bg-clip-text text-transparent">fairness and freedom</span>
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Every feature designed to give you control and transparency
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {features.map((feature, index) => (
              <div
                key={index}
                className="group bg-white rounded-2xl p-8 border-2 border-gray-100 hover:border-[#DB4789] transition-all duration-500 hover:shadow-xl hover:shadow-[#DB4789]/20"
              >
                {/* Icon */}
                <div className={`inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br ${feature.gradient} mb-6 group-hover:scale-110 transition-transform duration-500`}>
                  <feature.icon className="w-8 h-8 text-[#75055B] group-hover:text-[#DB4789] transition-colors duration-300" />
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold mb-3 group-hover:text-[#75055B] transition-colors duration-300">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
